export default {
	data() {
		return {
			playbackFunctions: {
				repeat: false
			}
		};
	},
	computed: {
	},
	mounted() {
		
	},
	destroyed() {
		
	},
	methods: {
		toggleRepeat() {
			this.playbackFunctions.repeat = !this.playbackFunctions.repeat;
		}
	}
};
